import { useRefreshAssetPath } from "../../../../hooks/useRefreshAssetPath";
import { Header as StoreHeader } from "../../../../types";
import {
  mapRelativeToPixels,
  getBackgroundStyle,
} from "../../../../helpers/itemsHelper";
import { forwardRef } from "react";
import { useTemplateData } from "../../../../hooks/useTemplateData";

type HeaderProps = {
  headerItem: StoreHeader;
  previewWidth: number;
  previewHeight: number;
  children?: React.ReactNode;
};

export const Header = forwardRef<HTMLDivElement, HeaderProps>(
  ({ headerItem, previewWidth, previewHeight, children }, ref) => {
    let headerImageAssetId: string | undefined;
    let headerImagePath: string | undefined;

    if (headerItem.view === "Picture") {
      headerImageAssetId = headerItem.banner?.assetId;
      headerImagePath = headerItem.banner?.path;
    }

    //will not be called if headerImagePath is provided
    const { asset: headerAsset } = useRefreshAssetPath({
      assetId: headerImageAssetId,
      path: headerImagePath,
    });
    const headerAssetPath = headerAsset?.path ?? headerImagePath;
    const backgroundUrl = headerAssetPath ? `url(${headerAssetPath})` : "unset";

    const {
      brandKitData: { brandKitPalette },
    } = useTemplateData();

    if (!headerItem.background && !headerItem.banner) return null;

    const backgroundValue = headerItem.background;

    return (
      <div
        ref={ref}
        style={{
          height: mapRelativeToPixels(headerItem.size.height, previewHeight),
          width: mapRelativeToPixels(headerItem.size.width, previewWidth),
          ...(backgroundValue
            ? getBackgroundStyle(backgroundValue, brandKitPalette)
            : {}),
          ...(headerItem.view === "Picture" && {
            backgroundImage: backgroundUrl,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          }),
          position: "absolute",
          top: mapRelativeToPixels(headerItem.position.y, previewHeight),
          left: mapRelativeToPixels(headerItem.position.x, previewWidth),
          zIndex: headerItem.layerIndex,
        }}
        data-testid="header"
      >
        {children}
      </div>
    );
  }
);

Header.displayName = "Header";
